import React, { useEffect, useState } from 'react';
import {
  Card,
  Text,
  Row,
  Col,
  Tabs,
  Justify,
  TabPanel,
} from 'tea-component';

import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import SingleSelect from '@home/components/SingleSelect';
import CommonBubble from '@home/components/CommonBubble';
interface ICardBoxInterFace {
  titleCom?: string | React.ReactNode;
  subTitleCom?: string | React.ReactNode;
  middleContentCom?: string | React.ReactNode;
  renderList: Array<any>;
  downloadClick?: () => any;
  className?: string;
  style?: any;
  isLoading: boolean;
  isNodata: boolean;
  isError: boolean;
  height?: any;
  bordered?: any;
  filterSlot?: React.ReactNode;
  defaultAvtive?: any;
  setCurrentDataType?: (svgType: string) => any;
  // 切换图类型触发
  onChangeChartType?: (tab: string) => void;
  selectOption?: any[];
  selected?: string;
  setSelected?: (value: string) => void;
  changeData?: (key: string, value: string | boolean | number) => any;
  dataKey?: string;
  children?: React.ReactNode;
  operationSlot?: React.ReactNode;
  isFullScreen?: boolean; // 是否全屏状态
  activeChart?: string; // 受控模式：当前激活的图表类型
  onActiveChartChange?: (type: string, svgType: string) => void; // 受控模式：图表类型变化回调
}

const defaultSvgTypeList = [
  {
    type: 'bar',
    svgType: 'column-chart',
    content: 'Bar Chart',
  },
  {
    type: 'line',
    svgType: 'discount-chart',
    content: 'Line Chart',
  },
  {
    type: 'table',
    svgType: 'sheet',
    content: 'Table',
  },
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function TableLine(props: ICardBoxInterFace, ref: any) {
  const {
    titleCom = <></>,
    subTitleCom,
    className = '',
    style = {},
    bordered = false,
    isLoading,
    isError,
    middleContentCom,
    isNodata,
    renderList,
    height,
    defaultAvtive = 0,
    filterSlot = null,
    setCurrentDataType,
    downloadClick,
    onChangeChartType,
    selectOption,
    selected,
    setSelected,
    changeData,
    dataKey,
    // eslint-disable-next-line react/prop-types
    children,
    operationSlot,
    isFullScreen = false,
    activeChart: externalActiveChart,
    onActiveChartChange
  } = props;

  // 支持受控和非受控两种模式
  const [internalActiveChart, setInternalActiveChart] = useState(
    renderList?.[defaultAvtive]?.type,
  );
  const [internalActiveSvgType, setInternalActiveSvgType] = useState(
    renderList?.[defaultAvtive]?.svgType,
  );
  
  // 使用受控模式的值，如果没有则使用内部状态
  const activeChart = externalActiveChart !== undefined ? externalActiveChart : internalActiveChart;
  const activeSvgType = internalActiveSvgType;
  const typeList = renderList?.map(item => item.type);

  let svgTypeList =
    renderList?.map((item) => ({
      type: item?.type,
      svgType: item?.svgType,
      content: item?.content,
      isHideCom: item?.isHideCom,
      isHideIcon: item?.isHideIcon
    })) || defaultSvgTypeList;
  if (activeSvgType === 'sheet')
    svgTypeList = svgTypeList?.filter((item) => item?.type !== 'eyes');

  const download = () => {
    downloadClick?.();
  };

  useEffect(() => {
    setCurrentDataType?.(renderList?.[defaultAvtive]?.type);
    
    // 受控模式下，初始化时同步默认值到父组件
    if (externalActiveChart === undefined || externalActiveChart === '') {
      const initialType = renderList?.[defaultAvtive]?.type;
      const initialSvgType = renderList?.[defaultAvtive]?.svgType;
      if (onActiveChartChange && initialType) {
        onActiveChartChange(initialType, initialSvgType);
      }
    }
  }, []);

  // console.log('activeChart',activeChart,activeChartRef?.current)
  useEffect(() => {
    // 兜底处理，不同指标切换时，如果当前选中的chat类型不在后面更新的renderList中，则默认取renderList的第一个展示
    if (!typeList?.includes(activeChart)) {
      const newType = renderList?.[defaultAvtive]?.type;
      const newSvgType = renderList?.[defaultAvtive]?.svgType;
      
      if (externalActiveChart !== undefined && onActiveChartChange) {
        // 受控模式：通知父组件
        onActiveChartChange(newType, newSvgType);
      } else {
        // 非受控模式：更新内部状态
        setInternalActiveChart(newType);
      }
      setInternalActiveSvgType(newSvgType);
    }
  }, [typeList, activeChart, externalActiveChart, onActiveChartChange]);

  return (
    <>
      <Card
        bordered={bordered}
        className={`dba_basic-cardbox table-line ${className}`}
        style={style}
      >
        <Card.Body
          className="dba_basic-cardbox-body"
          title={
            <>
              {titleCom && (
                <div className="dba_basic-cardbox-title table-title">
                  {titleCom}
                </div>
              )}
              {subTitleCom && <>{subTitleCom}</>}
            </>
          }
          operation={!selectOption ?
            <>
              {!isNodata &&
                svgTypeList?.map((t) => (
                  <>
                    {
                      !(t?.isHideIcon) && <CommonBubble
                        dark
                        placement="top"
                        content={t?.content || ''}
                        key={t.svgType}
                      >
                        <Text
                          className="table-btn table-line-show"
                          onClick={() => {
                            setCurrentDataType?.(t?.type);
                            if (t?.isHideCom) return;
                            
                            // 支持受控模式
                            if (externalActiveChart !== undefined && onActiveChartChange) {
                              onActiveChartChange(t?.type, t?.svgType);
                            } else {
                              setInternalActiveChart(t?.type);
                            }
                            setInternalActiveSvgType(t?.svgType);
                            onChangeChartType?.(t?.type);
                          }}
                        >
                          <SvgIcon
                            className={
                              activeChart !== t?.type
                                ? 'table-icon'
                                : 'action-icon'
                            }
                            type={t.svgType}
                          />
                        </Text>
                      </CommonBubble>
                    }
                  </>
                ))}
              {!isNodata && downloadClick && (
                <Text className="table-btn" onClick={download}>
                  <SvgIcon className={'table-icon'} type="download" />
                </Text>
              )}
              {/* 右侧操作区插槽 */}
              {operationSlot}
            </> : <SingleSelect
              options={selectOption}
              value={selected}
              // matchButtonWidth={true}
              onChange={(value) => {
                setSelected?.(value);
                changeData?.(dataKey as string, value);
              }}
              button={(selectedOption)=><div className='dba-select-button'>
                {selectedOption?.icon}
              </div>
              }
              searchable={false}
              // placeholder={selectPlaceholder}
              className="dba-chart-type-select"
              overlayClassName='dba-chart-type-select-overlay dba-nav-menu-overlay'
              placement="bottom-end"
              // 全屏时直接渲染到 body，避免层级问题
              getPopupContainer={isFullScreen ? () => document.body : undefined}
            />
          }
        >

          {filterSlot !== null && <Justify left={<div>{filterSlot}</div>} />}
          {middleContentCom && <>{middleContentCom}</>}
          <Tabs activeId={activeChart} tabs={renderList}>
            {
              children ? children : renderList?.map((item, index) => (
                <TabPanel id={item.type} key={index}>
                  <Row>
                    <Col span={24} className="dba_basic-cardbox-component-box">
                      <Abnormal
                        style={{ height: height ? height : 400 }}
                        component={item?.component}
                        isLoading={isLoading}
                        isError={isError}
                        isNoData={isNodata}
                      />
                    </Col>
                  </Row>
                </TabPanel>
              ))
            }
          </Tabs>
        </Card.Body>
      </Card>
    </>
  );
}
